import {memo, useEffect} from 'react';
import cn from 'classnames';

import styles from './ListTabs.module.scss';

interface Props<T> {
  className?: string;
  tabs: {label: string; value: T}[];
  tab?: T;

  activeTabValue?: T;
  onChange: (nextTabValue: T) => void;
}

function ListTabs({
  className,
  tab,
  tabs,
  activeTabValue,
  onChange,
}: Props<'payment_gateway' | 'other_integrations'>) {
  useEffect(() => {
    sessionStorage.setItem(
      tab as unknown as string,
      activeTabValue as unknown as string
    );
  }, [activeTabValue, tab]);

  return (
    <div className={cn(styles.root, className)}>
      {tabs.map((tab) => {
        return (
          <span
            key={tab.value}
            className={cn(styles.tab, {
              [styles['--active']]: tab.value === activeTabValue,
            })}
            onClick={() => {
              onChange(tab.value);
            }}
          >
            {tab.label}
          </span>
        );
      })}
    </div>
  );
}

export default memo(ListTabs);
